<template>
  <div class="p-3 pb-3 dd bg-primary">
    <b-tabs
      content-class="mt-3 "
      active-nav-item-class="font-weight-bold text-uppercase text-primary"
      active-tab-class="font-weight-bold text-success"
      fill
    >
      <b-tab :title="$t('photoCan')" active class="text-center">
        <div class="alert bg-white" style="width:100%;border:1px solid white">
          <div style="display:flex;align-items:center;justify-content:space-between">
            <div style="display:flex;align-items:center;">
              <div class="mr-2">
                <embed
                  width="80"
                  height="80"
                  :src="
              (candidateData.employeePhotoExtension == 'doc' ||
                  candidateData.employeePhotoExtension == 'docx') ?
                  require('@/assets/images/word.png') : candidateData.employeePhotoExtension == 'pdf' ?
                  require('@/assets/images/pdf.png')
                 : `${baseUrl}/${candidateData.employeePhotoUploadPath}`
               "
                />
              </div>
              <div>
                <h3 class="alert-title">{{candidateData.employeePhotoName}}</h3>
              </div>
            </div>
            <div class="flex-container">
              <a
                style="width: 190px"
                :href="`${baseUrl}/${candidateData.employeePhotoUploadPath}`"
                :download="`${candidateData.lastName} ${
                      candidateData.firstName
                    }.${candidateData.employeePhotoUploadPath.split('.').pop()}`"
                class="btn block btn-outline-primary btn-hover-primary"
              >
                <i class="fa fa-download"></i>
                {{ $t("actions.download") }}
              </a>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab :title="$t('employees.passport')" class="text-center">
        <div class="alert bg-white" style="width:100%;border:1px solid white">
          <div style="display:flex;align-items:center;justify-content:space-between">
            <div style="display:flex;align-items:center">
              <div class="mr-2">
                <embed
                  width="80"
                  height="80"
                  :src="
              (candidateData.employeePassportScannerType == 'doc' ||
                  candidateData.employeePassportScannerType == 'docx') ?
                  require('@/assets/images/word.png') : candidateData.employeePassportScannerType == 'pdf' ?
                  require('@/assets/images/pdf.png')
                 : `${baseUrl}/${candidateData.employeePassportScannerUploadPath}`
               "
                />
              </div>
              <div>
                <h3 class="alert-title">{{candidateData.employeePassportScannerName}}</h3>
              </div>
            </div>
            <div class="flex-container">
              <a
                style="width: 190px"
                :href="`${baseUrl}/${candidateData.employeePassportScannerUploadPath}`"
                :download="`${candidateData.lastName} ${
                      candidateData.firstName
                    }.${candidateData.employeePassportScannerUploadPath.split('.').pop()}`"
                class="btn block btn-outline-primary btn-hover-primary"
              >
                <i class="fa fa-download"></i>
                {{ $t("actions.download") }}
              </a>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab :title="$t('references.education')" class="text-center">
        <div class="alert bg-white"  style="width:100%;border:1px solid white">
          <div style="display:flex;align-items:center;justify-content:space-between">
            <div style="display:flex;align-items:center">
              <div class="mr-2">
                <embed
                  width="80"
                  height="80"
                  :src="
              (candidateData.employeeDiplomaType == 'doc' ||
                  candidateData.employeeDiplomaType == 'docx') ?
                  require('@/assets/images/word.png') : candidateData.employeeDiplomaType == 'pdf' ?
                  require('@/assets/images/pdf.png')
                 : `${baseUrl}/${candidateData.employeeDiplomaUploadPath}`
               "
                />
              </div>
              <div>
                <h3 class="alert-title">{{candidateData.employeeDiplomaName}}</h3>
              </div>
            </div>

            <div class="flex-container">
              <a
                style="width: 190px"
                :href="`${baseUrl}/${candidateData.employeeDiplomaUploadPath}`"
                :download="`${candidateData.lastName} ${
                      candidateData.firstName
                    }.${candidateData.employeeDiplomaUploadPath.split('.').pop()}`"
                class="btn block btn-outline-primary btn-hover-primary"
              >
                <i class="fa fa-download"></i>
                {{ $t("actions.download") }}
              </a>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab :title="$t('employees.ob')" class="text-center">
        <div class="alert bg-white"  style="width:100%;border:1px solid white">
          <div style="display:flex;align-items:center;justify-content:space-between">
            <div style="display:flex;align-items:center;">
              <div class="mr-2">
                <embed
                  width="80"
                  height="80"
                  :src="
              (candidateData.resumeType == 'doc' ||
                  candidateData.resumeType == 'docx') ?
                  require('@/assets/images/word.png') : candidateData.resumeType == 'pdf' ?
                  require('@/assets/images/pdf.png')
                 : `${baseUrl}/${candidateData.resumeUploadPath}`
               "
                />
              </div>
              <div>
                <h3 class="alert-title">{{candidateData.resumeName}}</h3>
              </div>
            </div>
            <div class="flex-container">
              <a
                style="width: 190px"
                :href="`${baseUrl}/${candidateData.resumeUploadPath}`"
                :download="`${candidateData.lastName} ${
                      candidateData.firstName
                    }.${candidateData.resumeUploadPath.split('.').pop()}`"
                class="btn block btn-outline-primary btn-hover-primary"
              >
                <i class="fa fa-download"></i>
                {{ $t("actions.download") }}
              </a>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab :title="$t('recruitment.additionalData')">
        <div
          class="alert bg-white both-clear"

          style="width:100%;border:1px solid white"
          v-for="(v, index) in otherFiles"
          :key="index"
        >
          <div style="display:flex;align-items:center;justify-content:space-between">
            <div style="display:flex;align-items:center">
              <div class="mr-2">
                <embed
                  width="80"
                  height="80"
                  :src="
              (v.fileType == 'doc' ||
                  v.fileType == 'docx') ?
                  require('@/assets/images/word.png') : v.fileType == 'pdf' ?
                  require('@/assets/images/pdf.png')
                 : `${baseUrl}/${v.uploadPath}`
               "
                />
              </div>
              <div>
                <h3 class="alert-title">{{v.name}}</h3>
              </div>
            </div>
            <div class="flex-container">
              <a
                style="width: 190px"
                :href="`${baseUrl}/${v.uploadPath}`"
                :download="`${candidateData.firstName} ${
                      candidateData.lastName
                    }.${v.uploadPath.split('.').pop()}`"
                class="btn block btn-outline-primary btn-hover-primary"
              >
                <i class="fa fa-download"></i>
                {{ $t("actions.download") }}
              </a>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  async mounted() {
    await this.setOtherFile(this.candidateData.id);
  },

  computed: {
    ...mapState("employee", ["candidateData", "otherFiles"])
  },
  methods: {
    ...mapActions("employee", ["setOtherFile"])
  }
};
</script>

<style lang="scss">
$success-color: #2ec946;

.dd {
  a {
    color: white;
    font-size: 16px;
    padding: 15px;
  }
}

.alert {
  padding: 16px;
  margin: 8px;
}

@mixin alert-2($color) {
  border-left: 4px solid $color;
  background-color: rgba($color, 0.05);

  .alert-title {
    color: $color;
  }
}

.alert-2-success {
  @include alert-2($success-color);
}

.alert-title {
  margin-top: 0;
  margin-bottom: 8px;
  font-size: 18px;
  font-family: "Poppins", sans-serif;
}

.alert-content {
  margin: 0;
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  color: #555555;
}
.flex-container {
  display: flex;
  justify-content: flex-end;
}
</style>
